var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app__body"},[_c('Side'),_c('Chat'),_c('router-view',{key:_vm.$route.fullPath,attrs:{"name":"number"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }